import { render, staticRenderFns } from "./PushDetailInfo.vue?vue&type=template&id=23950588&"
import script from "./PushDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./PushDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports